import React from "react";
import DojoView from "csi/page/DojoView";
import reflection from "csi/reflection";
import { useStore } from "csi/state/hooks";

export const ChangeLogOnInstance = () => {
	const { routerStore } = useStore();

	return (
		<DojoView
			fullHeight
			nodeUrl={routerStore.locationUrl}
			viewId="__LogDetailedView__"
			viewNodeType={reflection.TYPE_SITE}
			viewParams={{ bFocused: true }}
		/>
	);
};

export default ChangeLogOnInstance;
